import Deveui_UplinkModelBase from '../_generated/modelBases/deveui-uplink-model-base';

export default class Deveui_UplinkModel extends Deveui_UplinkModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
